import React, { ReactNode } from 'react';
import { I18n } from '@aws-amplify/core';
import { Col, Form, Row } from 'antd';

import { MailOutlined, QrcodeOutlined } from '@ant-design/icons';

import {
	ConfirmButton,
	Footer,
	MethodIcon,
	MethodInformations,
	MethodRadioButton,
	MethodRadioGroup,
	MethodTitle
} from './styles';
import { TFATypes } from '../types/request';
import { useTFAContext } from '../context';

interface DataType {
	title: string;
	description: string;
	icon: ReactNode;
	type: TFATypes;
	disabled: boolean;
}

export const Methods = () => {
	const { handleSelectedType, handleNextStep } = useTFAContext();

	const list: DataType[] = [
		{
			title: 'Authenticator app',
			description:
				'With this method, you will scan a QRCode so you can use your favorite authenticator app (such as Google Authenticator or Microsoft Authenticator). Then, all you have to do is type the code shown in your app when you login.',
			icon: <QrcodeOutlined />,
			type: 'AUTHENTICATOR',
			disabled: false
		},
		{
			title: 'E-mail',
			description:
				'With this method, you will receive the login code in your registered email. At the time of login, you must fill in the indicated field with the code sent to your email.',
			icon: <MailOutlined />,
			type: 'EMAIL',
			disabled: true
		}
	];

	function handleClick(type: TFATypes) {
		if (type) {
			handleSelectedType(type);
			handleNextStep();
		}
	}

	return (
		<Col span={24}>
			<Row justify="center">
				<Form.Item noStyle name="method_type">
					<MethodRadioGroup>
						{list.map((item) => (
							<MethodRadioButton key={item.title} value={item.type} disabled={item.disabled}>
								<div className="info">
									<MethodIcon>{item.icon}</MethodIcon>
									<MethodInformations>
										<MethodTitle>{I18n.get(item.title)}</MethodTitle>
										<span>{I18n.get(item.description)}</span>
									</MethodInformations>
								</div>
							</MethodRadioButton>
						))}
					</MethodRadioGroup>
				</Form.Item>
			</Row>
			<Footer>
				<Form.Item noStyle shouldUpdate>
					{({ getFieldValue }) => {
						const value = getFieldValue('method_type');

						return (
							<ConfirmButton type="primary" disabled={!value} onClick={() => handleClick(value)}>
								{I18n.get('Confirm')}
							</ConfirmButton>
						);
					}}
				</Form.Item>
			</Footer>
		</Col>
	);
};
